import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'nav-link active' : 'nav-link';
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <img
            src={logo}
            alt="TecnoVigilancia 360"
            style={{ width: "180px", height: "auto" }}
          />
        </Link>

        <button className="navbar-toggle" onClick={toggleMenu}>
          <span className="navbar-toggle-icon">{isOpen ? '✕' : '☰'}</span>
        </button>

        <ul className={isOpen ? 'navbar-menu active' : 'navbar-menu'}>
          <li className="navbar-item">
            <Link to="/" className={isActive('/')} onClick={() => setIsOpen(false)}>
              Inicio
            </Link>
          </li>
          <li className="navbar-item">
            <Link to="/about" className={isActive('/about')} onClick={() => setIsOpen(false)}>
              Nosotros
            </Link>
          </li>
          <li className="navbar-item">
            <Link to="/services" className={isActive('/services')} onClick={() => setIsOpen(false)}>
              Servicios
            </Link>
          </li>
          <li className="navbar-item">
            <Link to="/benefits" className={isActive('/benefits')} onClick={() => setIsOpen(false)}>
              Beneficios
            </Link>
          </li>
          <li className="navbar-item">
            <Link to="/contact" className={isActive('/contact')} onClick={() => setIsOpen(false)}>
              Contacto
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
